module.exports = __webpack_public_path__ + "img/Cert 06.27bbf521.png";